import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

export const topBar: ThemeApp['appComponents']['topBar'] = {
  components: {
    superAgentIndicator: {
      text: {
        defaultColor: themeUi.semantic.color.text.neutral700,
        notificationColor: themeUi.semantic.color.text.neutral100
      }
    },
    envBanner: {
      hrefText: {
        color: themeUi.semantic.color.text.neutral100,
        colors: themeUi.semantic.color.text
      },
      iconContainer: {
        fill: themeUi.semantic.color.icon.neutral100
      },
      verticalLine: {
        backgroundColor: themeUi.semantic.color.text.neutral100
      }
    },

    userMenu: {
      userMenu: {
        nameAndArrowContainer: {
          notifyColor: themeUi.semantic.color.text.secondary50,
          unnotifyColor: themeUi.semantic.color.text.secondary50
        },
        userName: {
          notifyColor: themeUi.semantic.color.text.secondary400,
          unnotifyColor: themeUi.semantic.color.text.secondary400,
          fontSize: themeUi.core.font.fontSize.s12
        },
        menuContainer: {
          notifyColor: themeUi.semantic.color.text.secondary50,
          unnotifyColor: themeUi.semantic.color.text.secondary50,

          notifyBackgroundColor: themeUi.semantic.color.background.secondary800,
          unnotifyBackgroundColor: themeUi.semantic.color.background.secondary800,

          fill: themeUi.semantic.color.icon.secondary50
        },
        arrowIcon: {
          fill: themeUi.semantic.color.icon.secondary400
        }
      },

      components: {
        userMenuContent: {
          userMenuContent: {
            container: {
              color: themeUi.semantic.color.text.neutral800
            },
            editProfileIcon: {
              fill: themeUi.semantic.color.icon.neutral700
            },
            signOutIcon: {
              stroke: themeUi.semantic.color.icon.neutral700
            },
            menuActionItem: {
              borderTop: themeUi.semantic.color.border.neutral400,
              backgroundColor: themeUi.semantic.color.text.neutral300
            },
            userName: {
              color: themeUi.semantic.color.text.neutral700
            }
          },

          components: {
            switchAccount: {
              accountNameAndId: {
                selectedColor: themeUi.semantic.color.text.primary600,
                unselectedColor: themeUi.semantic.color.text.neutral700,
                gap: themeUi.core.space.space100
              },
              accountItem: {
                backgroundColor: themeUi.semantic.color.background.neutral300
              }
            }
          }
        }
      }
    }
  }
};
